export const getModulesFromAuthState = (authState, searchType) => {
  const { modules } = authState
  const { modules: searchTypeModules } = (modules?.[searchType] ?? {})
  return searchTypeModules ?? {}
}
